export const GENERIC_INPUT_VALIDATION =
	"^[\\p{L}\\p{M}\\p{N}][ \\p{L}\\p{M}\\p{N}'-]*[\\p{L}\\p{M}\\p{N}]$"
